<template>
  <div class="ts-item-box">
    <img
      class="ts-item-cover"
      :src="
        cover && cover != 'null'
          ? $global.imgUrl + cover
          : require('@/assets/img/mobile-img/zz_default.png')
      "
      alt=""
    />
    <h3 class="ts-item-title" v-html="title"></h3>
    <div v-if="isExtend">
      <p class="extend-text">
        预计赚¥<span class="extend-text-price">{{ extendPrice }}</span>
      </p>
      <p class="extend-price">
        <span v-show="price[0] > 0" class="ts-item-icon">¥</span>
        <span class="ts-item-price">{{ formatePrice }}</span>
      </p>
    </div>
    <div v-else>
      <span v-show="price[0] > 0" class="ts-item-icon">¥</span>
      <span class="ts-item-price">{{ formatePrice }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cover", "title", "price", "isExtend", "extendPrice"],
  data() {
    return {
      searchStr: "",
    };
  },
  computed: {
    formatePrice() {
      if (this.price.length > 1) {
        return `${this.price[0]}-${this.price[this.price.length - 1]}`
      } else {
        return this.price[0] > 0 ? `${this.price[0]}` : "免费"
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ts-item-box {
  padding: 10px;
  // width: 170px;
  background: #ffffff;
  border-radius: 6px;

  .ts-item-cover {
    display: block;
    margin: 7px auto 27px;
    width: 100%;
    // height: 136px;
    object-fit: contain;
  }

  .ts-item-title {
    margin-bottom: 10px;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ts-item-icon {
    font-size: 12px;
    color: #ff3d3d;
  }

  .ts-item-price {
    font-size: 15px;
    font-weight: 700;
    color: #ff3d3d;
  }

  .extend-text {
    font-size: 12px;
    color: #ff3d3d;

    .extend-text-price {
      font-size: 16px;
      font-weight: 700;
    }
  }

  .extend-price {
    .ts-item-icon {
      color: #999999;
    }

    .ts-item-price {
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>